import React, { useState, useEffect, Fragment, useRef } from "react";
import SidebarStrain from './SidebarStrain';
import {
    Avatar, Box, Button, Grid, Paper, Table, TableCell, TableContainer, TableBody, TableHead,
    TableRow, TextField, Typography, Card, CardContent, CardHeader, Tooltip, Modal, Divider, Backdrop, CircularProgress
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import { DataGrid, GridToolbar, GridToolbarExport, GridToolbarQuickFilter } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';

import IconButton from '@mui/material/IconButton';
import config from '../../../config.json'
import moment from "moment";
import CountUp from 'react-countup';
import axios from 'axios';
import { disableBackButton } from '../../ConstantComponents/Constants'
import Footer from "../../Footer";
import StrainDataModal from '../StrainDashboard/StrainDataModal.tsx';


const useStyle = makeStyles({
    root: {
        "& .MuiDataGrid-columnHeaderTitle": {

            whiteSpace: "pre-wrap",
            lineHeight: 1,
            textAlign: "center",
            fontWeight: "bold",
            color: "#ba7704",
            fontSize: '1.3rem',
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        '& .MuiDataGrid-columnHeader': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        "& .MuiDataGrid-cellContent": {
            textOverflow: "clip",
            whiteSpace: "pre-wrap",
            lineHeight: 1,
            textAlign: "center",
            fontWeight: "bold",
        },
        "& .MuiTypography-string": {
            textOverflow: "ellipsis",
            whiteSpace: "break-spaces",
            lineHeight: 2,
            textAlign: "center",
            fontWeight: "bold",

        },
        boxShadow: 2,
        "& .MuiTablePagination-selectLabel": {
            marginTop: "auto",
        },
        "& .MuiTablePagination-displayedRows": {
            marginTop: "auto",
        },
    },
});

const BASE_URL = config.SERVER_URL;


export default function StrainDashboardNiced() {

    disableBackButton()

    const drawerWidth = 260;

    const [nicedStrains, setnicedStrains] = useState([])

    const [markettotal, setmarkettotal] = useState(0)
    const [hospitaltotal, sethospitaltotal] = useState(0)
    const [ssftotal, setssftotal] = useState(0)
    const [alltotal, setalltotal] = useState(0)
    const [animaltotal, setanimaltotal] = useState(0)


    const [pageSize, setPageSize] = useState(10);

    const [nicedstrains, setnicedstrains] = useState([]);

    const [value, setValue] = useState('1');

    const [centernameview, setcenternameview] = useState('')
    const [testsubcategorynameview, settestsubcategorynameview] = useState('')
    const [testpropertyview, settestpropertyview] = useState('')
    const [serotypeview, setserotypeview] = useState('')
    const [samplecategoryview, setsamplecategoryview] = useState('')
    const [samplesubcategoryview, setsamplesubcategoryview] = useState('')
    const [antibiogramview, setantibiogramview] = useState('')
    const [antiresistantview, setantiresistantview] = useState('')
    const [antiintermediateview, setantiintermediateview] = useState('')
    const [virulenceview, setvirulenceview] = useState('')
    const [nicedstrainidview, setnicedstrainidview] = useState('')
    const [updateddateview, setupdateddateview] = useState('')
    const [syssampleidview, setsyssampleidview] = useState('')
    const [icmrsampleid, seticmrsampleid] = useState('')
    const [testdate, settestdate] = useState('')
    const [surveynameview, setsurveynameview] = useState('')
    const [supercategorynameview, setsupercategorynameview] = useState('')
    const [statename, setstatename] = useState('')
    const [districtname, setdistrictname] = useState('')
    const [centername, setcentername] = useState('')

    const [viewformModal, setviewformModal] = useState(false)

    const [backdropopen, setbackdropopen] = useState(true)

    const [loading, setloading] = useState(true);

    const classes = useStyle();

    const [straindata, setStraindata] = useState({
        sysStrainId: "",
        strainId: "",
        sample_id: "",
        centerName: "",
        surveyName: "",
        subcategoryName: "",
        propertyName: "",
        serotype: "",
        sampleCategoryName: "",
        sampleSubcategoryName: "",
        superCategoryName: "",
        antibioticSensitive: "",
        antibioticIntermediate: "",
        antibioticResistant: "",
        virulenceGene: "",
        updatedDate: "",
        testDate: "",
        stateName: "",
        districtName: ""
    })

    const style2 = {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: 'auto',
        maxHeight: '90vh',
        transform: 'translate(-50%, -50%)',
        margin: 'auto'


    }

    const CustomToolbar = () => (
      <div style={{
          paddingLeft: '15px',
          paddingRight: '15px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
      }}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5px'}}>
              <GridToolbarQuickFilter/>
          </div>
      </div>
    );

    useEffect(() => {

        const getStrains = axios.post(BASE_URL+"/strain/viewStrainNiced",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        const getCardStats = axios.post(BASE_URL+"/straindashboard/getCardStatsForNiced",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        Promise.all([getStrains, getCardStats])
            .then(function (responses) {

                setloading(false)

                setnicedStrains(responses[0].data.Strains)
                setmarkettotal(responses[1].data.MarketTot)
                sethospitaltotal(responses[1].data.HospitalTot)
                setssftotal(responses[1].data.SsfTot)
                setalltotal(responses[1].data.AllTotal)
                setanimaltotal(responses[1].data.AnimalTot)

                setbackdropopen(false)
            })
            .catch(function (errors) {

                //////console.log("strain errors", errors[0]);
            });

    }, [])



    /////////////////////////////// niced strain view col def  ///////////////////////////////////

    const columns = [

        {
            field: "icmrStrainId",
            headerName: "Strain ID",
            flex: 0.8, align: 'center', headerAlign: 'center',

        }
        ,
        {
            field: "surveyName",
            headerName: "Surveillance Type",
            flex: 1.5, align: 'center', headerAlign: 'center'
        },
        {
            field: "pathogen",
            headerName: "Pathogen Identified",
            flex: 2, align: 'center', headerAlign: 'center',
            valueGetter: (params) => {
                const subcategory = params.row.subcategoryName || "";
                const property = params.row.propertyName === "Positive" ? "" : `(${params.row.propertyName})`;
                return `${subcategory} ${property}`.trim();
            },
            renderCell: (params) => {
                return (<> <Typography variant="string" style={{ fontStyle: 'italic' }} >
                    {params.row.subcategoryName} &nbsp;
                </Typography>
                    <Typography variant="string" style={{ fontStyle: 'italic' }} >
                        {params.row.propertyName === "Positive" ? "" : `(${params.row.propertyName})`}
                    </Typography>
                </>)
            }
        },
        {
            field: "serotype",
            headerName: "Serotype",
            flex: 1,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                const value = params.row.serotype;
                return (
                  <Typography variant="string">
                      {value === "Not Available" ? "Awaited" : value}
                  </Typography>
                );
            },
        },
        {
            field: "testDate",
            headerName: "Isolation Year",
            flex: 0.8, align: 'center', headerAlign: 'center',
            renderCell: (params) => {
                return (<Typography variant="string" >
                    {moment(params.row.testDate).format('YYYY')}
                </Typography>)
            }
        },
        {
            field: "View",
            renderCell: (cellValues) => {
                return (
                    <IconButton
                        //   variant="contained"
                        //   color="primary"
                        //   size='medium'
                        //   startIcon={<EditIcon></EditIcon>}

                        onClick={(event) => {
                            //handleViewOpen(event, cellValues);
                            handleviewformModal(event, cellValues);
                        }}
                    >
                        <DesktopWindowsOutlinedIcon></DesktopWindowsOutlinedIcon>
                    </IconButton>
                );
            }, flex: 0.5, align: 'center', headerAlign: 'center'
        }
    ];

    const handleviewformModal = (event, cellValues) => {
        setviewformModal(true)

        ////console.log("values", cellValues)

        setcenternameview(cellValues.row.centerName)
        setStraindata(prevState =>  {
            return {
                ...prevState,
                centerName:  cellValues.row.centerName,
                subcategoryName:  cellValues.row.subcategoryName,
                sampleCategoryName:   cellValues.row.sampleCategoryName,
                sampleSubcategoryName:   cellValues.row.sampleSubcategoryName,
                propertyName:   cellValues.row.propertyName,
                antibioticSensitive:  cellValues.row.antibioticSensitive,
                virulenceGene:  cellValues.row.virulenceGene,
                strainId:  cellValues.row.icmrStrainId,
                updatedDate:   cellValues.row.updatedDate,
                surveyName:   cellValues.row.surveyName,
                serotype:   cellValues.row.serotype,
                antibioticIntermediate:   cellValues.row.antibioticIntermediate,
                antibioticResistant:    cellValues.row.antibioticResistant,
                testDate:  cellValues.row.testDate,
                stateName:    cellValues.row.stateName,
                districtName:   cellValues.row.districtName,
                sample_id: cellValues.row.sample_id,

            }
        })
        settestsubcategorynameview(cellValues.row.subcategoryName)
        setsamplecategoryview(cellValues.row.sampleCategoryName)
        setsamplesubcategoryview(cellValues.row.sampleSubcategoryName)
        settestpropertyview(cellValues.row.propertyName)
        setantibiogramview(cellValues.row.antibioticSensitive)
        setvirulenceview(cellValues.row.virulenceGene)
        setnicedstrainidview(cellValues.row.icmrStrainId)
        setupdateddateview(cellValues.row.test)
        setsyssampleidview()
        setsurveynameview(cellValues.row.surveyName)
        setsupercategorynameview(cellValues.row.superCategoryName)
        settestpropertyview(cellValues.row.propertyName)
        setserotypeview(cellValues.row.serotype)
        setantiintermediateview(cellValues.row.antibioticIntermediate)
        setantiresistantview(cellValues.row.antibioticResistant)
        settestdate(cellValues.row.testDate)
        setstatename(cellValues.row.stateName)
        setdistrictname(cellValues.row.districtName)
        setcentername(cellValues.row.centerName)
        seticmrsampleid(cellValues.row.sample_id)

    }

    const handleviewformModalClose = () => {
        setviewformModal(false)
    }


    /////////////////////////////// niced strain view col def  ///////////////////////////////////



    return (
        <>

            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` }
                }}>
                <SidebarStrain />
                <div style={{ marginTop: '70px' }}>
                    <div className="body flex-grow-1" style={{ backgroundColor: '#f3f4f7', }}>
                        <div className="row p-3">

                            <div className="row">

                                <Grid container spacing={2} justifyContent="center" alignItems="center" >

                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} >
                                        <div style={{
                                            backgroundColor: '#dd3f3f', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%'
                                        }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'white' }}><CountUp end={alltotal} /></h3>
                                            <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'white' }}>Total Strains</h6>

                                            {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>




                                </Grid>
                                <div style={{marginTop: 20}}>

                                </div>

                                <Grid container spacing={2} justifyContent="center" alignItems="center" >
                                    <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                        <div style={{
                                            backgroundColor: '#de8e09', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%'
                                        }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'white' }}><CountUp end={markettotal} /></h3>
                                            <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'white' }}>Market Surveillance</h6>

                                            {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                        <div style={{
                                            backgroundColor: '#62b866', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%'
                                        }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'white' }}><CountUp end={hospitaltotal} /></h3>
                                            <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'white' }}>Hospital Surveillance</h6>

                                            {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                        <div style={{
                                            backgroundColor: '#449ef0', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%'
                                        }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'white' }}><CountUp end={ssftotal} /></h3>
                                            <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'white' }}>State Specific Food Surveillance</h6>

                                            {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={4} xl={3} >
                                        <div style={{
                                            backgroundColor: '#b58aed', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%'
                                        }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'white' }}><CountUp end={animaltotal} /></h3>
                                            <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'white' }}>Animal Surveillance</h6>

                                            {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>
                                </Grid>

                            </div>

                            <div className="container" style={{ marginBottom: 200 }}>
                                <h2 className="rubik-font" style={{ fontWeight: 400, textAlign: 'center', marginBottom: 20, marginTop: 50, color: "black" }}>Strain Information</h2>
                                <Box sx={{ height: 500, justifyContent: "center" }}>
                                    <DataGrid
                                        className={classes.root}
                                        sx={{
                                            boxShadow: 2,
                                            "& .MuiTablePagination-selectLabel": {
                                                marginTop: "auto",
                                            },
                                            "& .MuiTablePagination-displayedRows": {
                                                marginTop: "auto",
                                            },
                                            "& .MuiDataGrid-cell": {
                                                padding: 0.5,
                                            },
                                            overflowX: "hidden",
                                            borderRadius: 2,
                                            padding: 2,
                                            border: "1px solid",
                                            backgroundColor: "#ffffff"
                                        }}
                                        rows={nicedStrains}
                                        getRowId={(r) => r.sysStrainId}
                                        columns={columns}
                                        components={{ Toolbar: CustomToolbar }}
                                        componentsProps={{
                                            toolbar: {
                                                showQuickFilter: true,
                                            },
                                        }}
                                        loading={loading}
                                        pageSize={pageSize}
                                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                        pagination
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        disableVirtualization
                                        disableSelectionOnClick={true}
                                        rowHeight={50}
                                        disableRowSelectionOnClick
                                        enableColumnAutosize
                                        autoHeight
                                        disableColumnMenu={true}
                                    />
                                </Box>
                            </div>

                        </div>
                    </div>
                </div>
                <Footer />

            </Box>

            {viewformModal && (
                <StrainDataModal
                    data={straindata}
                    onClose={() => setviewformModal(false)}
                />
            )}

            {/* view modal */}
            {/**view modal */}
            {/*<Modal*/}
            {/*    open={viewformModal}*/}
            {/*    onClose={handleviewformModalClose}*/}
            {/*    aria-labelledby="parent-modal-title"*/}
            {/*    aria-describedby="parent-modal-description"*/}
            {/*>*/}
            {/*    <Box sx={style2}>*/}
            {/*        <div style={{ alignItems: 'end', justifyItems: 'end', display: 'grid', marginBottom: '-40px' }}>*/}
            {/*            <Tooltip title='Close'>*/}
            {/*                <IconButton*/}
            {/*                    sx={{*/}
            {/*                        color: 'rgb(255, 255, 255)'*/}
            {/*                    }}*/}
            {/*                    onClick={(event) => {*/}
            {/*                        handleviewformModalClose(event)*/}


            {/*                    }}*/}
            {/*                >*/}
            {/*                    <CloseIcon />*/}
            {/*                </IconButton>*/}
            {/*            </Tooltip>*/}
            {/*        </div>*/}

            {/*        <Card sx={{ width: '100%', height: 'auto', alignItems: 'center', boxShadow: 10, borderRadius: 3, display: 'grid', backgroundColor: "#ffffff" }}>*/}
            {/*            <CardHeader*/}
            {/*                title={'Strain ID: ' + ' ' + nicedstrainidview}*/}
            {/*                //subheader={'ICMR Sample ID: ' + ' ' + icmrsampleid}*/}
            {/*                style={{ textAlign: 'left' }}*/}
            {/*                titleTypographyProps={{ variant: 'h5', fontWeight: 'bold', color: 'white' }}*/}
            {/*                subheaderTypographyProps={{ variant: 'h6', fontWeight: 'bold', color: 'white' }}*/}
            {/*                sx={{ justifyContent: 'center', display: 'grid', background: '#45a2fa' }}*/}

            {/*            >*/}
            {/*            </CardHeader>*/}
            {/*            /!* <Divider sx={{ bgcolor: "secondary.light" }} orientation="horizontal" flexItem /> *!/*/}
            {/*            <Divider style={{ width: '500%', background: 'black' }} >*/}

            {/*            </Divider>*/}


            {/*            <CardContent>*/}

            {/*                <Box*/}
            {/*                    component="form"*/}
            {/*                    sx={{*/}

            {/*                        display: "flex",*/}
            {/*                        flexDirection: "column",*/}
            {/*                        alignItems: "center",*/}
            {/*                        overflowY: 'auto',*/}
            {/*                        height: '500px'*/}

            {/*                    }}*/}
            {/*                    noValidate*/}
            {/*                    autoComplete="off"*/}
            {/*                >*/}
            {/*                    <Grid container spacing={1} >*/}
            {/*                        <Grid item xs={12}>*/}
            {/*                            <h4 className="rubik-font" style={{ fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Sample Details</h4>*/}
            {/*                            <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 2 }}></Divider>*/}
            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1">*/}
            {/*                                SAMPLE ID:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'flex-start', display: 'grid' }}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {icmrsampleid}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}

            {/*                        <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1" >*/}
            {/*                                Sample Category:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'flex-start', display: 'grid' }}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {samplecategoryview}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1">*/}
            {/*                                Sample Sub-Category:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'flex-start', display: 'grid' }}>*/}

            {/*                            <Typography variant="subtitle1"  >*/}
            {/*                                {samplesubcategoryview}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}

            {/*                        <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1" >*/}
            {/*                                Isolation Year:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'flex-start', display: 'grid' }}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {moment(testdate).format("YYYY")}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1">*/}
            {/*                                State:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={3}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {statename}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}

            {/*                        <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1" >*/}
            {/*                                District:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={3}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {districtname}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={12} md={12} sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}  >*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', textAlign: 'center' }} variant="subtitle1">*/}
            {/*                                Center: &nbsp;*/}
            {/*                            </Typography>*/}
            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {centername}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6}>*/}



            {/*                        </Grid>*/}

            {/*                        <Grid item xs={12}>*/}
            {/*                            <h4 className="rubik-font" style={{ fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Pathogen Details</h4>*/}
            {/*                            <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 2 }}></Divider>*/}
            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1">*/}
            {/*                                Identified pathogen:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6}>*/}

            {/*                            <Typography variant="subtitle1" sx={{ fontStyle: 'italic' }} >*/}
            {/*                                {testsubcategorynameview} {testpropertyview === "Positive" ? "" : `(${testpropertyview})`}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}

            {/*                        <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1" >*/}
            {/*                                Serotype:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {serotypeview ? serotypeview : "Not Available"}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={12} >*/}

            {/*                            <h4 className="rubik-font" style={{ fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Antibiogram and Virulence Genes Details</h4>*/}
            {/*                            <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 2 }}></Divider>*/}
            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1">*/}
            {/*                                Antibiotic Sensitive:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {antibiogramview === "" ? "Not Available" : antibiogramview}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}

            {/*                        <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1" >*/}
            {/*                                Antibiotic Resistant:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {antiresistantview === "" ? "Not Available" : antiresistantview}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1" >*/}
            {/*                                Antibiotic Intermediate:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {antiintermediateview === "" ? "Not Available" : antiintermediateview}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6}>*/}

            {/*                            <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', alignItems: 'center', justifyContent: 'right', display: 'grid' }} variant="subtitle1" >*/}
            {/*                                Virulence Genes:*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}
            {/*                        <Grid item xs={6} md={6}>*/}

            {/*                            <Typography variant="subtitle1" >*/}
            {/*                                {virulenceview === "" ? "Not Available" : virulenceview}*/}
            {/*                            </Typography>*/}

            {/*                        </Grid>*/}



            {/*                    </Grid>*/}
            {/*                </Box>*/}


            {/*            </CardContent>*/}



            {/*        </Card>*/}


            {/*    </Box>*/}
            {/*</Modal>*/}

            <Backdrop
                sx={{ color: "#000000", zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'rgba(255,255,255,0.9)' }}
                open={backdropopen}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}
